import React, { useRef } from "react";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../Utils/Utils";

const libraries = ["places"];

const GoogleAddressAutocomplete = ({ onPlaceSelected }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAP_KEY, // or process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    libraries,
  });

  const autocompleteRef = useRef(null);

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place?.geometry) {
        onPlaceSelected({
          address: place.formatted_address,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
      }
    }
  };

  if (!isLoaded) return <p>Loading Google Maps...</p>;

  return (
    <Autocomplete
      onLoad={(ref) => (autocompleteRef.current = ref)}
      onPlaceChanged={handlePlaceChanged}
      options={{
        componentRestrictions: { country: [] },
      }}
    >
      <input
        type="text"
        placeholder="Enter address"
        className="form-control"
        style={{ width: "100%" }}
      />
    </Autocomplete>
  );
};

export default GoogleAddressAutocomplete;
